import { FC, ReactElement, ReactNode, useMemo } from 'react'
import cn from 'classnames'

import SvgIcon from 'components/atoms/SvgIcon'
import SuccessSvg from 'icons/success.svg'

import styles from 'components/features/rewards/rewardPage/WaysToEarn/WaysToEarnRow.styl'

type WaysToEarnRowProps = {
  isCompleted: boolean
  whatToDoColumnNode: ReactNode
  benefitColumnNode?: ReactNode
  className?: string
}

export const WaysToEarnRow: FC<WaysToEarnRowProps> = ({
  isCompleted,
  whatToDoColumnNode,
  benefitColumnNode,
  className,
}): ReactElement => {
  const completedIcon = useMemo((): ReactElement => {
    if (isCompleted) {
      return <SvgIcon className={ styles.iconCompleted } src={ SuccessSvg } />
    }
    return <div className={ styles.iconToDo } />
  }, [isCompleted])

  return (
    <div className={ cn(styles.container, { [styles.completed]: isCompleted }, className) }>
      <div className={ styles.iconColumn }>
        { completedIcon }
      </div>
      <div className={ styles.whatToDoColumn }>
        { whatToDoColumnNode }
      </div>
      { benefitColumnNode && (
        <div className={ styles.benefitsColumn }>
          { benefitColumnNode }
        </div>
      ) }
    </div>
  )
}
